<template>
  <div class="device">
    <div class="col">
      <img v-if="devices[0].image" class="avatar" :src="devices[0].image" alt="">
      <div class="empty" v-else>
        <div>{{$t('device.deviceImage')}}</div>
      </div>
    </div>
    <!-- <div class="col"> -->
    
    <div class="info">
      <div class="attr">
        <div class="key">{{$t('device.deviceModel')}}:</div>
        <div class="value">{{devices[0].deviceExtension.deviceModel.name}}</div>
      </div>
      <div class="attr">
        <div class="key">{{$t('device.deviceIMEI')}}:</div>
        <div class="value">{{devices[0].deviceExtension.imei}}</div>
      </div>
      
      <div class="attr">
        <div class="key">{{$t('device.deviceExtra')}}:</div>
        <div class="value">{{devices[0].deviceExtension.attrs.extra || '---'}}</div>
      </div>
      
      <div class="attr">
        <div class="key">{{$t('device.devicePhoneNo')}}:</div>
        <div class="value">{{devices[0].deviceExtension.phoneNo || '---'}}</div>
      </div>
      <div class="attr">
        <div class="key">{{$t('device.releaseDate')}}:</div>
        <div class="value">{{devices[0].registerTimestamp ? formatTime(devices[0].registerTimestamp, true) : '---'}}</div>
      </div>
      
    </div>

    <div class="status">
      
      <div class="attr">
        <div class="key">{{$t('device.renewalDate')}}:</div>
        <div class="value">{{devices[0].deviceExtension.paymentTimestamp ? formatTime(devices[0].deviceExtension.paymentTimestamp, true) : '---'}}</div>
      </div>

      <div class="attr">
        <div class="key">{{$t('device.finallyOnline')}}:</div>
        <div class="value">
          <span>{{formatTime(devices[0].timestamp)}}</span>
        </div>
      </div>

      <div class="attr">
        <div class="key">{{$t('device.devicePower')}}:</div>
        <div class="value">
          <!-- <i class="icon-online" :title="`电量${devices[0].power}%`">
            <zx-icon :type="computedDevicePowerIcon(devices[0].power)"></zx-icon>
          </i> -->
          <span>{{devices[0].power ? `${devices[0].power}%` : ''}}</span>
        </div>
      </div>

      <div class="attr">
        <div class="key">{{$t('device.onlineStatu')}}:</div>
        <div class="value">
          <!-- <i :class="devices[0].isOnline ? 'icon-online' : ''" :title="devices[0].isOnline ? '在线' : '离线'">
            <zx-icon type="icon-shoubiao"></zx-icon>
          </i> -->
          <span>{{devices[0].isOnline ? $t('home.online') : $t('home.offline')}}</span>
        </div>
      </div>

      <div class="attr">
        <div class="key">{{$t('device.bandStatu')}}:</div>
        <div class="value">
          <!-- <i class="" :title="computedDeviceBandIcon(devices[0].attrs).text">
            <zx-icon :type="computedDeviceBandIcon(devices[0].attrs).icon"></zx-icon>
          </i> -->
          <span>{{computedDeviceBandIcon(devices[0].attrs).text}}</span>
        </div>
      </div>
      
      
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
// import moment from 'moment'
import {computedDevicePowerIcon, computedDeviceBandIcon} from '../../../utils/homeFn'
export default {
  props: {
    devices: {
      required: true,
      type: Array
    }
  },
  methods: {
    computedDevicePowerIcon,
    computedDeviceBandIcon,
    formatTime (timeStamp, onlyDay=false) {
      if (!timeStamp || timeStamp == -1) {
        return ''
      } else {
        if (onlyDay) {
          return this.$moment(timeStamp * 1000).format('YYYY-MM-DD')
        } else {
          return this.$moment(timeStamp * 1000).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
  },
  mounted () {
    // console.log(this.devices)
  }
}
</script>
<style lang="less" scoped>
@import '../../../theme/color.less';
.device {
  width: 100%;
  // display: flex;
  // flex-direction: row;
  display: grid;
  grid-template-columns: 200px 350px 1fr;
  // justify-content: space-between;
  .col {
    padding: 0 30px;
    
    
    .avatar {
      max-width: 100px;
    }
    .empty {
      width: 70px;
      height: 98px;
      border: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #999;
      font-size: 11px;
    }
  }
  .status {
    // display: grid;
    // grid-template-columns: 130px 20px 20px 20px;
    // grid-gap: 20px;
    // justify-content: space-between;
    // height: 50px;
    // line-height: 50px;
    .attr {
      display: flex;
      font-size: 1.1em;
      padding-bottom: 5px;
      .key {
        color: @text-color;
      }
      .value {
        color: @heading-color;
        margin-left: 10px;
      }
    }
  }
  .info {
    .attr {
      display: flex;
      font-size: 1.1em;
      padding-bottom: 5px;
      .key {
        color: @text-color;
      }
      .value {
        color: @heading-color;
        margin-left: 10px;
      }
    }
  }
}
</style>
